import { Box } from '@mui/material';
import { forwardRef } from 'react';
import type { ReactNode } from 'react';
import SimpleBar, { Props } from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

interface ScrollbarProps extends Props {
  children?: ReactNode;
}

export const Scrollbar = forwardRef<HTMLDivElement, ScrollbarProps>((props, ref) => {
  const { children, ...other } = props;

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );

  if (isMobile) {
    return (
      <Box ref={ref} sx={{ overflowX: 'auto' }} {...other}>
        {children}
      </Box>
    );
  }

  return (
    <SimpleBar
      // @ts-expect-error TYPESCRIPT THROWING ERROR EVEN THOUGH SIMPLEBAR ACCEPTS REF
      ref={ref}
      {...other}>
      {children}
    </SimpleBar>
  );
});
